import z from "zod";

export default z.object({
  products: z.array(z.object({
    offer_declined: z.boolean().optional(),
    accepted_quotes: z.array(z.string().optional()).optional().default([]),
    available_quotes: z.number(),
    selection_required: z.boolean().default(true)
  }))
});
